export enum PaymentMethod {
  NONE = 0,
  PIN = 1,
  INVOICE = 2,
}
